import React from "react";
import { Button } from "reactstrap";
import "../../Styles/BadgeButton.scss";
import { cx, css } from "emotion";

type Props = {
  color?: string;
  textColor?: string;
  borderColor?: string;
  disabled?: boolean;
  onClick?: () => void;
  title?: string;
  classNameDisabled?: string;
  classNameEnabled?: string;
};

export const BadgeButton: React.FC<Props> = props => (
  <Button
    outline
    size="sm"
    title={props.title}
    disabled={props.disabled}
    onClick={props.onClick}
    className={cx(
      props.classNameEnabled ? props.classNameEnabled : "",
      props.classNameDisabled ? props.classNameDisabled : "badge-button-disabled",
      css`
        padding: 2px 6px 2px 6px;
        font-size: 12px;
        background-color: ${props.color} !important;
        color: ${props.textColor} !important;
        border-color: ${props.borderColor} !important;
      `
    )}
  >
    {props.children}
  </Button>
);

BadgeButton.defaultProps = {
  disabled: false
};
